<!--
 * @Date: 2022-08-16 11:56:34
 * @LastEditTime: 2022-09-26 15:10:23
 * @FilePath: /vue-medweb/packages/vue-m-community/src/components/Loading/index.vue
 * @Description: loading组件
-->
<template>
  <div>
    <cube-loading />
  </div>
</template>

<script>
export default {
  name: 'Loading',
  props: {
    text: {
      type: String,
      default: '加载中...',
    },
    isSpecial: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.loading-wrap {
  position: fixed;
  top: 45%;
  left: 50%;
  z-index: 5000;
  transform: translate(-50%, -50%);
}
.special-loading {
  padding: rem(15);
  background-color: rgba(0, 0, 0, 0.7);
  border-radius: rem(6);
}
</style>
